module.exports = __webpack_public_path__ + "static/img/sliver.0ffb9d8f.png";